<template>
  <el-form ref="form" :model="{}" label-width="200px" :rules="rules">
    <el-form-item label="流量范围">
      <el-radio-group v-model="outterForm.union">
        <el-radio-button ghost label="NONE">默认</el-radio-button>
        <el-radio-button ghost label="CUSTOM" disabled>百青藤</el-radio-button>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="转化类型" :prop="platform === 3 ? 'transName' : 'transFromTypeName'">
      <el-select v-if="platform === 3" v-model="convert_params.transName" filterable placeholder="请选择" @change="selectConvert">
        <el-option v-for="c in miniProgramConvertList" :key="c.appTransId" :label="c.transName" :value="c.appTransId"> </el-option>
      </el-select>

      <el-select v-else v-model="convert_params.transFromTypeName" filterable placeholder="请选择" @change="selectConvert">
        <el-option v-for="c in convertList" :key="c" :label="c" :value="c"> </el-option>
      </el-select>
    </el-form-item>
  </el-form>
</template>
<script>
import { isArray } from '@/common/js/utils'

import { getConvertList, getConvert } from '@/api/baidu.model'
import { getCaoHuaGames } from '@/api/common.model'
import { makeStreamRules } from './data/form-rules.js'
import convertList from '@/data/baidu/convert_data'
export default {
  data() {
    return {
      rules: { ...makeStreamRules.call(this) },
      gameItem: null,
      form: {
        union: '默认'
      },
      convertList: convertList,
      miniProgramConvertList: []
    }
  },
  computed: {
    formData() {
      return this.$store.getters['Baidu/currTaskParams']
    },
    outterForm() {
      return this.formData.outterForm
    },
    innerForm() {
      return this.formData.innerForm
    },

    platform() {
      return this.innerForm.ch_platform_id
    },

    convert_params: {
      get() {
        return this.formData.convert_params
      },
      set(form) {
        this.$store.commit('Baidu/UPDATE_CONVERT_PARAMS', form)
      }
    }
  },
  methods: {
    selectConvert(val) {
      const { ch_platform_id, game_id } = this.innerForm
      const { ad_account_id } = this.formData
      getConvertList({
        accountIds: [ad_account_id],
        platform: ch_platform_id,
        downloadUrl: this.gameItem.game_address,
        apkName: this.gameItem.ad_package,
        game_id
      })
        .then((data) => {
          if (data && isArray(data)) {
            const convertItem = data.filter((c) => c.transFromTypeName === val).pop()
            this.convert_params = {
              ...convertItem,
              platform: ch_platform_id,
              gameId: game_id,
              downloadUrl: this.gameItem.game_address,
              apkName: this.gameItem.ad_package
            }
          }
        })
        .catch((err) => console.log(err))
    },
    getInitData() {
      const { game_id } = this.innerForm
      getCaoHuaGames()
        .then((data) => {
          if (data && isArray(data) && game_id) {
            this.gameItem = data.filter((g) => g.id === game_id).pop()
          }
        })
        .catch((err) => console.log(err))

      // 小程序平台获取转化
      if (this.platform === 3) {
        const { ad_account_id } = this.formData
        getConvert({ transFrom: 7, ad_account_id }).then((data) => {
          this.miniProgramConvertList = data
        })
      }
    },
    formValidate() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate((valid) => {
          if (valid) {
            resolve()
          } else {
            reject(new Error('basic'))
          }
        })
      })
    }
  },
  created() {
    this.getInitData()
  }
}
</script>
<style lang="scss" scoped></style>
